<h1 matDialogTitle><fa-icon icon="percent"></fa-icon> Rabatte</h1>

<ng-container *ngFor="let form of shownArlAllowanceFormArray; let i = index; let last = last">
    <form>
        <div class="flex gap-4 flex-wrap items-center">
            <mat-form-field>
                <mat-label>Titel</mat-label>
                <input matInput type="text" placeholder="Mengenrabatt" [formControl]="form.controls.title" />
                <mat-error *ngIf="form.controls.title.invalid"> {{ GetErrorMessage(form.controls.title) }}</mat-error>
            </mat-form-field>
            <mat-form-field class="small-form-field">
                <mat-label>in %</mat-label>
                <app-number-transform-input [factor]="-1" [formControl]="form.controls.percent"></app-number-transform-input>
                <!--                        <input type="number" matInput [formControl]="form.controls.percent" />-->
                <span matSuffix>%</span>
                <mat-error *ngIf="form.controls.percent.invalid"> {{ GetErrorMessage(form.controls.percent) }}</mat-error>
            </mat-form-field>
            <button mat-icon-button (click)="remove(i)" matTooltip="löschen" color="warn" type="button"><fa-icon icon="trash"></fa-icon></button>
        </div>
    </form>
    <mat-divider *ngIf="!last"></mat-divider>
</ng-container>
<button mat-raised-button (click)="addClick()"><fa-icon icon="plus"></fa-icon> Rabatt hinzufügen</button>
<mat-dialog-actions class="justify-end">
    <!--    <button app-button Inverted mat-dialog-close Color="cancel">schließen</button>-->
    <button app-button mat-dialog-close [Disabled]="invalid()" Color="green">speichern</button>
</mat-dialog-actions>
